<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div class="card">
      <div class="card-title px-2 pt-2 w-100">
        <div [ngClass.xl]="'float-left'" [ngClass.md]="'float-left'" [ngClass.sm]="'mb-075'">
          <input type="search" id="datatable-search-input" [placeholder]="'SEARCH' | translate" autocomplete="off" class="form-control" [(ngModel)]="searchKeyword" (ngModelChange)="filterCompanyOffices()" />
        </div>
        <div class="float-right">
          <div [ngClass.xl]="'w-fit d-inline-block mr-2'" [ngClass.md]="'w-fit d-inline-block mr-2'" [ngClass.sm]="'d-none'">
            <app-select-table-limit [defaultValue]="tableLimit" (onChange)="tableLimit = $event"></app-select-table-limit>
          </div>
          <a (click)="modalOpen(typeAdd, null)" has_capability="create_company_office" class="btn btn-outline-primary text-primary">{{ "ADD" | translate }}</a>
        </div>
      </div>
      <div class="card-body p-0">
        <ngx-datatable
          class="bootstrap core-bootstrap"
          columnMode="force"
          [headerHeight]="30"
          [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
          [scrollbarH]="true"
          [rowHeight]="_utilService.isDesktop ? 50 : 170"
          [limit]="tableLimit"
          [footerHeight]="60"
          [rows]="filteredCompanyOffices"
          [sorts]="[{ prop: 'name', dir: 'ASC' }]">
          <ngx-datatable-column [name]="'NAME' | translate" prop="name" [sortable]="true" *ngIf="_utilService.isDesktop" width="300">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.name }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'ADDRESS' | translate" prop="other.address" [sortable]="true" *ngIf="_utilService.isDesktop" width="400">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.other.address }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'CONTRACT_STRING' | translate" prop="other.contract_string" [sortable]="true" *ngIf="_utilService.isDesktop" width="400">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.other.contract_string }}</span>
            </ng-template>
          </ngx-datatable-column>
          <!-- <ngx-datatable-column [name]="'COORDINATES' | translate" prop="other.coordinates" [sortable]="true" *ngIf="_utilService.isDesktop" width="400">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.other.coordinates }}</span>
            </ng-template>
          </ngx-datatable-column> -->
          <ngx-datatable-column name="{{ 'ACTIONS' | translate }}" [sortable]="false" width="200" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex align-items-center">
                <button (click)="modalOpen(typeEdit, row)" class="bg-transparent border-0 text-secondary pr-1" has_capability="edit_company_office">
                  <i [data-feather]="'edit-2'" size="19"></i>
                </button>
                <button (click)="deleteType(row)" class="bg-transparent border-0 text-danger remove-item" has_capability="delete_company_office">
                  <i [data-feather]="'trash-2'" size="19"></i>
                </button>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <ng-template ngx-datatable-cell-template let-row="row" *ngIf="!_utilService.isDesktop">
            <div class="row list-item-mobile">
              <div class="col-12">
                <span class="font-weight-bold">{{ "NAME" | translate }}: </span>
                <span>{{ row.name }}</span>
              </div>
              <div class="col-12">
                <span class="font-weight-bold">{{ "ADDRESS" | translate }}: </span>
                <span>{{ row.other.address }}</span>
              </div>
              <div class="col-12">
                <span class="font-weight-bold">{{ "CONTRACT_STRING" | translate }}: </span>
                <span>{{ row.other.contract_string }}</span>
              </div>
              <div class="col-12">
                <span class="font-weight-bold">{{ "COORDINATES" | translate }}: </span>
                <span>{{ row.other.coordinates }}</span>
              </div>
              <div class="col-12 mt-075 text-right" [ngClass.md]="'pr-2'">
                <button (click)="modalOpen(typeEdit, row)" class="bg-transparent border-0 text-secondary pr-1" has_capability="edit_company_office">
                  <i [data-feather]="'edit-2'" size="19"></i>
                </button>
                <button (click)="deleteType(row)" class="bg-transparent border-0 text-danger remove-item" has_capability="delete_company_office">
                  <i [data-feather]="'trash-2'" size="19"></i>
                </button>
              </div>
            </div>
          </ng-template>
        </ngx-datatable>
      </div>
    </div>
  </div>
</div>

<!-- Modal Add -->
<ng-template #typeAdd let-modal>
  <div class="modal-header">
    <div></div>
    <button type="button" class="close" (click)="modal.close('Cross click')" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0">
    <h3>{{ "ADD_NEW_COMPANY_OFFICE" | translate }}</h3>
    <div class="row">
      <div class="form-group col-12">
        <label for="name">{{ "NAME" | translate }}<sup class="text-danger">*</sup></label>
        <input [(ngModel)]="typeForm.name" name="name" type="text" id="name" class="form-control" />
        <div class="font-error" *ngIf="showModalError && (!typeForm.name || typeForm.name.length < 1)">{{ "ERRORS.INSERT_NAME" | translate }}</div>
      </div>
      <div class="form-group col-12">
        <label for="address">{{ "ADDRESS" | translate }}<sup class="text-danger">*</sup></label>
        <input [(ngModel)]="typeForm.other.address" name="address" type="text" id="address" class="form-control" />
        <div class="font-error" *ngIf="showModalError && (!typeForm.other.address || typeForm.other.address.length < 1)">{{ "ERRORS.INSERT_ADDRESS" | translate }}</div>
      </div>
      <div class="form-group col-12">
        <label for="contract_string">{{ "CONTRACT_STRING" | translate }}<sup class="text-danger">*</sup></label>
        <input [(ngModel)]="typeForm.other.contract_string" name="contract_string" type="text" id="contract_string" class="form-control" />
        <div class="font-error" *ngIf="showModalError && (!typeForm.other.contract_string || typeForm.other.contract_string.length < 1)">{{ "ERRORS.INSERT_CONTRACT_STRING" | translate }}</div>
      </div>
      <div class="form-group col-12">
        <label for="coordinates">{{ "COORDINATES" | translate }}</label>
        <input [(ngModel)]="typeForm.other.coordinates" name="coordinates" type="text" id="coordinates" class="form-control" />
      </div>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-outline-primary w-150" (click)="modal.close()" rippleEffect>
      {{ "CANCEL" | translate }}
    </button>
    <button type="submit" class="btn btn-primary w-150" rippleEffect (click)="addType()">
      {{ "SAVE" | translate }}
    </button>
  </div>
</ng-template>
<!-- / Modal Add -->

<!-- Modal Edit -->
<ng-template #typeEdit let-modal>
  <div class="modal-header">
    <div></div>
    <button type="button" class="close" (click)="modal.close('Cross click')" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0">
    <h3>{{ "EDIT_COMPANY_OFFICE" | translate }}</h3>
    <div class="row">
      <div class="form-group col-12">
        <label for="name-edit">{{ "NAME" | translate }}<sup class="text-danger">*</sup></label>
        <input [(ngModel)]="typeForm.name" name="name" type="text" id="name-edit" class="form-control" />
        <div class="font-error" *ngIf="showModalError && (!typeForm.name || typeForm.name.length < 1)">{{ "ERRORS.INSERT_NAME" | translate }}</div>
      </div>
      <div class="form-group col-12">
        <label for="address-edit">{{ "ADDRESS" | translate }}<sup class="text-danger">*</sup></label>
        <input [(ngModel)]="typeForm.other.address" name="address" type="text" id="address-edit" class="form-control" />
        <div class="font-error" *ngIf="showModalError && (!typeForm.other.address || typeForm.other.address.length < 1)">{{ "ERRORS.INSERT_ADDRESS" | translate }}</div>
      </div>
      <div class="form-group col-12">
        <label for="contract_string-edit">{{ "CONTRACT_STRING" | translate }}<sup class="text-danger">*</sup></label>
        <input [(ngModel)]="typeForm.other.contract_string" name="contract_string" type="text" id="contract_string-edit" class="form-control" />
        <div class="font-error" *ngIf="showModalError && (!typeForm.other.contract_string || typeForm.other.contract_string.length < 1)">{{ "ERRORS.INSERT_CONTRACT_STRING" | translate }}</div>
      </div>
      <div class="form-group col-12">
        <label for="coordinates-edit">{{ "COORDINATES" | translate }}</label>
        <input [(ngModel)]="typeForm.other.coordinates" name="coordinates" type="text" id="coordinates-edit" class="form-control" />
      </div>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-outline-primary w-150" (click)="modal.close()" rippleEffect>{{ "CANCEL" | translate }}</button>
    <button type="submit" class="btn btn-primary w-150" rippleEffect (click)="editType()">{{ "SAVE" | translate }}</button>
  </div>
</ng-template>
<!-- / Modal Edit -->